import { useState } from 'react'
import { SystemSS } from '../../components/SystemSS'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const ButtleFlowStep5 = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <section>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='gameflow button'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-step5.webp`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                <p className=' '>
                    To clear a map, you will have to defeat all enemies by <span className='text-pborange'>decreasing their HP to 0</span>. Once an enemy’s HP
                    gets to 0, they will become incapacitated. You can also <span className='text-pborange'>remove them from the map entirely by making
                    them Fallen</span>. In addition, there are some maps with <span className='text-pborange'>special victory</span> conditions that will be displayed
                    at the start of a map.
                </p>{' '}
                <p className=' '>
                    Characters who take damage and reach 0 HP will become incapacitated and fall where they stand. <span className='text-pborange'>If
                    they are revived, they can participate in battle again.</span>
                </p>{' '}
                <p className=' '>
                    If incapacitated characters are not revived and they take additional damage, they will become Fallen
                    and <span className='text-pborange'>completely disappear</span>.
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-5',
                            index: 1,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='Fallen allies can be revived via Revive at the home base.
'
                />
            </div>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </section>
    )
}
